// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Ovfc","box":"WorkspacesBox_box__1BxxD","node":"WorkspacesBox_node__QRpyx"};